import react, { createContext, useEffect, useLayoutEffect, useState } from 'react';
import { api, refreshApi } from '../api/axios';
import { AuthContextType, User, Role } from '../types/auth';


export const AuthContext = createContext<AuthContextType | null>(null);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isAuthLoading, setIsAuthLoading] = useState(true);
    const [accessToken, setAccessToken] = useState<string | null>(null);
    const [user, setUser] = useState<User | null>(null);
  
    const login = (token: string, userData: User) => {
      setAccessToken(token);
      setUser(userData);
    };
  
    const logout = async () => {
      setAccessToken(null);
      setUser(null);
      await api.post("/auth/logout");

    };
  
    useEffect(() => {
        console.log('Use Effect AuthContext');
        const refresh = async () => {
            try {
                console.log('useEffect Refreshing token...');
                const res = await refreshApi.post("/auth/refresh-token");
                setAccessToken(res.data.data.accessToken);
                setUser(res.data.data.user);
                console.log('useEffect Refresh Response', res.data.data.accessToken);
                
            } catch(error) {
                console.error('useEffect Refresh Error', error);
                setAccessToken(null);
                setUser(null);
            }
            finally {
                setIsAuthLoading(false);
            }
        };
  
        refresh();
    }, []);

    useLayoutEffect(() => {
        const interceptor = api.interceptors.request.use((config) => {

            if(!config._retry && accessToken)
                config.headers.Authorization = `Bearer ${accessToken}`
            
            return config;
        });

        return () => {
            api.interceptors.request.eject(interceptor);
        }
    }, [accessToken])

    useLayoutEffect(() => {
        const interceptor = api.interceptors.response.use(
            (response) => response,
            async (error) => {
                const originalRequest = error.config;

                if (error.response && error.response.status === 401 && !originalRequest._retry) {
                    try {
                        console.error("Interceptor caught 401, refreshing token...", originalRequest);
                        const res = await refreshApi.post("/auth/refresh-token");
                        setAccessToken(res.data.data.accessToken);
                        setUser(res.data.data.user);
                        originalRequest._retry = true;
                        originalRequest.headers.Authorization = `Bearer ${res.data.data.accessToken}`;
                        return api(originalRequest);
                    } catch (error) {
                        setAccessToken(null);
                        setUser(null);
                    }
                }
                return Promise.reject(error);
        });

        return () => {
            api.interceptors.response.eject(interceptor);
        }
    }, [])
  
    return (
      <AuthContext
        value={{
          user,
          login,
          logout,
          isAuthenticated: !!accessToken,
          isAuthLoading
        }}
      >
        {children}
      </AuthContext>
    );
  };